"use client";

import React, { useState, useEffect } from "react";
import Image from "next/image";

const Feature = () => {
  const [activeFeature, setActiveFeature] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveFeature((prev) => (prev === 1 ? 2 : 1));
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const heading = [
    "Compare outputs from different models",
    "Generate instant moodboards from a single prompt",
  ];

  const feature1 = [
    {
      title: "Multiple tabs to compare models",
      image:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1746940422/Group_10_fn4slw.webp",
    },
    {
      title: "Single prompt = Single output",
      image:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747383017/Group_14_1_oty69s.webp",
    },
  ];

  const feature2 = [
    {
      title: "Save time with bundled mode",
      image:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1746940422/Group_11_nmogtj.webp",
    },
    {
      title: "One prompt to create 10 images of different styles",
      image:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747383018/Group_13_1_nweofc.webp",
    },
  ];
  return (
    <div className="inline-flex w-full flex-col items-center justify-center gap-5 font-medium md:gap-10 md:pt-[81px] md:pb-[55px]">
      <div className="flex flex-col items-center justify-center gap-5 self-stretch md:gap-10">
        <div className="inline-flex w-full flex-col items-center justify-center gap-1.5 py-2.5 md:gap-3.5">
          <div className="w-full max-w-[596px] justify-start text-center text-xl font-semibold text-white md:text-[38px] md:leading-[50px]">
            Ideate with the{" "}
            <span className="bg-gradient-to-b from-[#6CB5FF] to-[#1E7BDB] bg-clip-text text-transparent">
              Speed of Light
            </span>
          </div>
          <div className="justify-center text-sm font-medium text-[#b3b3b3] md:text-lg">
            {heading[activeFeature - 1]}
          </div>
        </div>
        <div className="flex w-full max-w-[1177px] flex-col items-center justify-center gap-5 px-[12.5px] md:flex-row md:px-5">
          {/* Before Section */}
          <div className="flex h-[325px] w-full flex-col items-center justify-between gap-5 rounded-xl bg-white/10 pt-2 pb-3.5 outline-1 outline-white/20 md:h-[486px] md:gap-6 md:pt-2.5">
            <div className="inline-flex w-20 items-center justify-center gap-[5px] rounded-[10px] bg-[#e84e53]/25 p-2 text-lg text-[#e84e53] md:p-2.5 md:text-base">
              Before
            </div>
            <div className="relative w-full flex-1">
              <Image
                src={feature1[activeFeature - 1].image}
                alt="Before"
                className="object-contain"
                fill
                sizes="(max-width: 768px) 100vw, 50vw"
                loading="lazy"
              />
            </div>
            <div className="text-center text-sm text-[#e4e4e4] md:text-base">
              {feature1[activeFeature - 1].title}
            </div>
          </div>

          {/* After Section */}
          <div className="flex h-[325px] w-full flex-col items-center justify-between gap-5 rounded-xl bg-white/10 pt-2 pb-3.5 outline-1 outline-white/20 md:h-[486px] md:gap-6 md:pt-2.5">
            <div className="flex w-20 items-center justify-center gap-[5px] rounded-[10px] bg-[#3dc13c]/25 p-2 text-lg text-[#3dc13c] md:p-2.5 md:text-base">
              After
            </div>
            <div className="relative w-full flex-1">
              <Image
                src={feature2[activeFeature - 1].image}
                alt="After"
                className="object-contain"
                fill
                sizes="(max-width: 768px) 100vw, 50vw"
                loading="lazy"
              />
            </div>
            <div className="text-center text-sm text-[#e4e4e4] md:text-base">
              {feature2[activeFeature - 1].title}
            </div>
          </div>
        </div>
        <div className="flex-start gap-[12.65px]">
          <button
            onClick={() => setActiveFeature(1)}
            className={`h-[5px] w-[25px] cursor-pointer rounded-xl bg-white ${activeFeature === 1 ? "bg-white" : "bg-white/25"}`}
          />
          <button
            onClick={() => setActiveFeature(2)}
            className={`h-[5px] w-[25px] cursor-pointer rounded-xl bg-white ${activeFeature === 2 ? "bg-white" : "bg-white/25"}`}
          />
        </div>
      </div>
    </div>
  );
};

export default Feature;
